import { useEffect } from 'react';

/**
 * **전체 화면 창이 떠 있는 동안 뒤 페이지 스크롤을 잠근다 — 인라인 값이 아니라 html 클래스로, 떠 있는 창 수를 세어.**
 *
 * 휴대폰 공략·공지·전투기록 창(사용자 2026-10-28 전체 화면)은 처음에 body·html 의 overflow 를 직접 'hidden' 으로 바꾸고
 * 닫을 때 그 전 값을 되돌렸다. 그런데 목록 쪽 `useBodyScrollLock` 도 같은 값을 바꾸고 되돌려서, 두 잠금이 풀리는 차례에 따라
 * 한쪽이 '잠긴 값'을 그 전 값으로 기억해 되돌렸다 — [내 룬으로 맞추기]로 룬피팅 탭에 넘어가면 페이지가 잠긴 채 남아
 * 아래로 스크롤이 안 됐다(사용자 2026-10-28). 클래스는 인라인 값과 따로라 서로 덮어쓰지 않고, 마지막 창이 닫힐 때만 뗀다.
 * 손가락 끌기는 막지 않는다 — 창 안 내용은 그대로 내린다(useBodyScrollLock 은 문서 전체 touchmove 를 막는다).
 */
const CLASS = 'scroll-locked';
let count = 0;

export function useScrollLockClass(locked: boolean): void {
    useEffect(() => {
        if (!locked) return;
        count += 1;
        document.documentElement.classList.add(CLASS);
        return () => {
            count = Math.max(0, count - 1);
            if (!count) document.documentElement.classList.remove(CLASS);
        };
    }, [locked]);
}
